import React, { useState } from 'react'
import './navbar.css'
import logo from '../../assets/logo.png';
import menu from '../../assets/menu.png'
import { Link } from 'react-scroll';
import pdf from '../../assets/Mohsin_Shah_Resume.pdf';


const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  
  const scrollToSection = (sectionId, offset = 0) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  
  const onResumeClick = async () => {
    try {
      // Fetch the PDF file
      const response = await fetch(pdf);
      const blob = await response.blob();
      
      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Create download link
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "Mohsin_Shah_Resume.pdf";
      
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading resume:', error);
      // Fallback to direct download
      const link = document.createElement("a");
      link.href = pdf;
      link.download = "Mohsin_Shah_Resume.pdf";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  
  return (
    <nav className="navbar">
      <img src={logo} alt="Mohsin Shah Logo" className='logo' />
      <div className="desktopMenu">
        <Link activeClass='active' to='intro' spy={true} smooth={false} offset={-100} duration={500} className="desktopMenuListItem" spyThrottle={100} onClick={(e) => { e.preventDefault(); scrollToSection('intro', 100); }}>Home</Link>
        <Link activeClass='active' to='skills' spy={true} smooth={false} offset={50} duration={500} className="desktopMenuListItem" spyThrottle={100} onClick={(e) => { e.preventDefault(); scrollToSection('skills', -50); }}>About</Link>
        <Link activeClass='active' to='experience' spy={true} smooth={false} offset={50} duration={500} className="desktopMenuListItem" spyThrottle={100} onClick={(e) => { e.preventDefault(); scrollToSection('experience', -50); }}>Experience</Link>
        <Link activeClass='active' to='works' spy={true} smooth={false} offset={30} duration={500} className="desktopMenuListItem" spyThrottle={100} onClick={(e) => { e.preventDefault(); scrollToSection('works', 150); }}>Projects</Link>
        <Link activeClass='active' to='clients' spy={true} smooth={false} offset={-70} duration={500} className="desktopMenuListItem" spyThrottle={100} onClick={(e) => { e.preventDefault(); scrollToSection('clients', 70); }}>Affiliations</Link>
        <Link activeClass='active' to='contact' spy={true} smooth={false} offset={-100} duration={500} className="desktopMenuListItem" spyThrottle={100} onClick={(e) => { e.preventDefault(); scrollToSection('contact', 100); }}>Contact Me</Link>
      </div>
      <div className="navbarButtons">
        <button className="desktopMenuBtn resumeBtn" onClick={onResumeClick} aria-label="Download resume">
          Resume
        </button>
      </div>

      <img src={menu} alt="Menu" className='mobMenu' onClick={()=>setShowMenu(!showMenu)} aria-label="Toggle menu"/>
      <div className="navMenu" style={{display: showMenu? 'flex':'none'}}>
        <Link activeClass='active' to='intro' spy={true} smooth={false} offset={-100} duration={500} className="listItem" onClick={(e) => { e.preventDefault(); setShowMenu(false); scrollToSection('intro', 100); }} spyThrottle={100}>Home</Link>
        <Link activeClass='active' to='skills' spy={true} smooth={false} offset={50} duration={500} className="listItem" onClick={(e) => { e.preventDefault(); setShowMenu(false); scrollToSection('skills', -50); }} spyThrottle={100}>About</Link>
        <Link activeClass='active' to='experience' spy={true} smooth={false} offset={50} duration={500} className="listItem" onClick={(e) => { e.preventDefault(); setShowMenu(false); scrollToSection('experience', -50); }} spyThrottle={100}>Experience</Link>
        <Link activeClass='active' to='works' spy={true} smooth={false} offset={30} duration={500} className="listItem" onClick={(e) => { e.preventDefault(); setShowMenu(false); scrollToSection('works', 150); }} spyThrottle={100}>Projects</Link>
        <Link activeClass='active' to='clients' spy={true} smooth={false} offset={-70} duration={500} className="listItem" onClick={(e) => { e.preventDefault(); setShowMenu(false); scrollToSection('clients', 70); }} spyThrottle={100}>Affiliations</Link>
        <Link activeClass='active' to='contact' spy={true} smooth={false} offset={-100} duration={500} className="listItem" onClick={(e) => { e.preventDefault(); setShowMenu(false); scrollToSection('contact', 100); }} spyThrottle={100}>Contact Me</Link>
        <button className="listItem" onClick={()=>{setShowMenu(false); onResumeClick();}}>Resume</button>
      </div>

    </nav>
  )
}

export default Navbar;